module.exports = __webpack_public_path__ + "static/media/Abbey-Knoll-Amended-By-Laws.f51ef9c7.pdf";